import React, { useEffect } from "react";
import Layout from "../components/Layout/Layout";
import LayoutBanner from "../components/Layout/LayoutBanner";
import { Grid, Typography } from "@mui/material";
import BTable from "../components/Table/Table";
import banner from '../assets/banner_mapping.svg'
import { useDispatch, useSelector } from "react-redux";
import { getMappedFields } from "../redux/slices/mappedSlice";
import Loader from "../components/Loader/Loader";
import api from '../Api'

const MappingFields = () => {
  const mappedFields = useSelector(state => state.mappedFields.data);
  const isLoading = useSelector(state => state.mappedFields.isLoading);
  const authData = useSelector((state) => state.auth.data);

  const dispatch = useDispatch();

  useEffect(() => {
    if (authData.access_token !== "") {
      api.defaults.headers.common.Authorization = authData?.access_token
        ? `Bearer ${authData?.access_token}`
        : "";
        dispatch(getMappedFields());
    }
  }, [dispatch, authData]);
 


  return (
    <Layout>
      <LayoutBanner
        title={"Mapped Field"}
        body={
          "The mapping fields serve as a crucial reference for tracking which specific data fields are being updated or transferred from Classe365 to the SkyPrep database. This ensures transparency and accuracy during the synchronization process, allowing us to understand exactly which data  is being updated between the two systems."
        }
        image={banner}
      />
      <Loader message={'Loading'} show={isLoading}/>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          display={"flex"}
          justifyContent={"space-between"}
          marginTop={"2px"}
        >
          <Typography className="heading">Mapped Field List</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} my={2}>
          <BTable
             rows={[
              { name: "Classe365", field: "classe" },
              { name: "Skyprep", field: "skyprep" },
              { name: "Description", field: "description" },
            ]}
            // data={[
            //   {
            //     classe365: "first_name",
            //     skyprep: "first_name",
            //     description: "First Name",
                
            //   },
            //   {
            //     classe365: "last_name",
            //     skyprep: "last_name",
            //     description: "Last Name",
                
            //   },
            //   {
            //     classe365: "student_email",
            //     skyprep: "email",
            //     description: "Email",
                
            //   },
            //   {
            //     classe365: "student_contact",
            //     skyprep: "phone",
            //     description: "Phone",
                
            //   },
            //   {
            //     classe365: "address",
            //     skyprep: "address",
            //     description: "Address",
                
            //   },
            //   {
            //     classe365: "admission_number",
            //     skyprep: "user_identifier",
            //     description: "Admission Number",
                
            //   },
              
            // ]}
            data={mappedFields}
          />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default MappingFields;
